import React from 'react';

import StepTimer from 'notebook/protocols/viewer/StepTimer';
import {ElementKeyboardEvent} from 'util/Types';

import {Step} from '../StepConstants';

interface TimerEditableWrapperProps {
  locked?: boolean;
  step: Step;
  index: number;
  visible?: boolean;
  isMultiEditable: boolean;
  deleteHandler: () => void;
  updateTimeHandler: (time: number) => void;
  setSelection: (selection: SelectionRestoreData) => void;
  storeState: () => void;
  restoreState: (
    e: ElementKeyboardEvent,
    selection: {
      selection: SelectionRestoreData;
    }
  ) => boolean;
}

export default function TimerEditableWrapper(props: TimerEditableWrapperProps): JSX.Element {
  return (
    <div className="timer-editable-wrapper">
      {!props.locked ? (
        <a className="del-timer-btn big-btn del-btn round-btn" onClick={props.deleteHandler}>
          {'\u00D7'}
        </a>
      ) : undefined}
      <StepTimer
        inline={true}
        originalMS={props.step?.timer?.milliseconds!}
        allowEdits={!props.locked}
        editHelpers={{
          cid: props.step.cid,
          updateTimeHandler: props.updateTimeHandler,
          setSelection: props.setSelection,
          storeState: props.storeState,
          restoreState: props.restoreState,
        }}
      />
    </div>
  );
}
